// extracted by mini-css-extract-plugin
export default {"expand":"expandedStyles_expand__olOFq","expandOpen":"expandedStyles_expandOpen__QSXj4"};